import { Icons } from '@journ/ui/icons'
import { Button } from '@journ/ui/button'
import { tv } from '@/libs/tv'
import { useIntlayer } from 'react-intlayer'
import { useSearch } from '../hooks/use-search'

const searchButton = tv({
	base: 'relative min-w-62.5 w-full justify-start text-sm text-muted-foreground sm:pr-12 md:w-40 lg:w-64 border-0 p-0 hover:bg-transparent font-normal hidden md:flex',
})

const kbd = tv({
	base: 'pointer-events-none absolute right-1.5 top-1.5 hidden h-5 select-none items-center gap-1 border bg-transparent px-1.5 text-xxs font-medium sm:flex',
})

const SearchButton = () => {
	const content = useIntlayer('search')
	const { toggle } = useSearch()

	return (
		<Button variant='outline' className={searchButton()} onClick={toggle}>
			<Icons.Search size={18} className='mr-2' />
			<span>{content.placeholder}</span>
			<kbd className={kbd()}>
				<span className='text-xs'>⌘</span>K
			</kbd>
		</Button>
	)
}

export { SearchButton }
